export default function getCurrencies(setCurrencies, setShowOverlay, setError) {
  if (!window.OrendaGetResponse || window.isSiteBuilder) {
    setTimeout(() => {
      // setCurrencies([{name: "EUR", isCard: true}, {name: "EUR"}]);
      setCurrencies([{name: "GBP"}, {name: "EUR"}]);
      // setCurrencies(["GBP"]);
      setShowOverlay(false);
    }, 1000);
    return;
  }

  window.OrendaGetResponse({ event_name: "getAccountInfo" }, (response) => {
    if (response.error) return setError(true);
    setCurrencies(response.accountInfo.map((x) => { return {name: x.currency, isCard: x.isCard} }));
    setShowOverlay(false);
    return;
  });
  return;
}
